import React from 'react';

import {
  BusinessGiftCardBlock,
} from '../../components/BusinessGiftCardBlock/BusinessGiftCardBlock';
import { featureStateHooks } from '../../hooks/featureStateHooks/featureStateHooks';
import { layoutHooks } from '../../hooks/layoutHooks/layoutHooks';
import { modalHooks } from '../../hooks/modalHooks/modalHooks';
import { ModalTypes } from '../../types/Modals';
import { BigBottomBlock } from '../../types/apiTypes';

export type Props = {
  data: BigBottomBlock;
};

export const BusinessGiftCardBlockContainer = (props: Props) => {
  const { data } = props;
  const { isDesktop } = layoutHooks.useDesktop();
  const isMobile = layoutHooks.useMobileLayout();
  const brandsModalProps = modalHooks.useModal(ModalTypes.BrandsModal);

  const {
    isEmblaSliderOn,
  } = featureStateHooks.useFeatureToggles();

  return (
    <BusinessGiftCardBlock
      backgroundColor={data.backgroundColor}
      brands={data.brands}
      button={data.button}
      image={data.image}
      showHand={data.showHand}
      title={data.title}
      usps={data.usps}
      isDesktop={isDesktop}
      isMobile={isMobile}
      brandsModalProps={brandsModalProps}
      isEmblaSliderOn={isEmblaSliderOn}
    />
  );
};

BusinessGiftCardBlockContainer.displayName = 'BusinessGiftCardBlockContainer';
